import Compressor from 'compressorjs';
export default function ImageCompressor(file) {
    return new Promise((resolve, reject) => {
        let rate = 0.6;
        let compre = true;
        if (file.size < 1000000){
            compre = false;
        } else if (file.size < 3000000){
            rate = 0.8;
        }
        
        new Compressor(file, {
            quality:rate, //压缩质量
            success(result) {
                if (compre){
                    result = new File([result], file.name, {type: file.type, lastModified: Date.now()});
                    resolve(result);
                } else {
                    resolve(file)
                }
            },
            error(err) {
                console.log("图片压缩失败");
                reject(err);
            }
        })

    })
}